import { Avatar, Box, Breadcrumbs, Button, Grid, Stack, Typography } from '@mui/material';
import { useEffect, useMemo, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';
import { Page } from '../../../design/page/Page';
import { useRequester } from '../../../hooks';
import { EikenMaterialResource, type EikenMaterialData } from '../../../resources';
import { EikenMaterialGeneratedForm } from './components/EikenMaterialGeneratedForm';
import { LibraryAdd } from '@mui/icons-material';

export function EikenMaterialUpdateGenerated() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const itemInitials =
    (user?.data.firstName?.charAt(0) || '') + (user?.data.lastName?.charAt(0) || '');
  const [searchParams] = useSearchParams();
  const id = searchParams.get('id');
  const ids = useMemo(() => id?.split(',') || [], [id]);
  const [activeTab, setActiveTab] = useState(0);
  const currentId = ids[activeTab];
  const fetchMaterial = useRequester<EikenMaterialResource>({
    onSubmit: (id) => EikenMaterialResource.fetchOne(id),
    onError: console.log,
  });
  const data = EikenMaterialResource.get(currentId).data as EikenMaterialData;

  useEffect(() => {
    fetchMaterial.submit(currentId);
  }, [currentId]);

  async function saveAllTests() {
    navigate('/eiken-materials');
  }

  if (!id || !data) return <></>;

  return (
    <Page>
      <Page.Header sx={{ height: 'auto', pt: 4, pb: 2, mb: 2 }}>
        <Stack direction="row" alignItems="center" spacing={2} sx={{ mb: 2 }}>
          <Link to="/eiken-materials">
            <Typography color="text.secondary" variant="body2">
              &lt; Back to questions
            </Typography>
          </Link>
        </Stack>
        <div className="flex justify-between">
          <Stack direction="row" alignItems="center" spacing={2} sx={{ mb: 3 }}>
            <Avatar
              sx={{
                bgcolor: 'border.primary',
                width: 56,
                height: 56,
                fontSize: 24,
                fontWeight: 600,
              }}
            >
              {itemInitials}
            </Avatar>
            <div>
              <Breadcrumbs aria-label="breadcrumb">
                <Link className="underline" color="inherit" to="/eiken-materials">
                  Questions
                </Link>
                <Typography color="text.primary">Update Material</Typography>
              </Breadcrumbs>
              <Typography variant="h3" sx={{ fontWeight: 600 }}>
                Update materials
              </Typography>
            </div>
          </Stack>
          <div>
            <Button
              variant="contained"
              color="primary"
              startIcon={<LibraryAdd />}
              onClick={saveAllTests}
            >
              <span>Save all tests</span>
            </Button>
          </div>
        </div>
      </Page.Header>
      <Page.Content>
        <Grid container spacing={2} sx={{ maxWidth: 900, mx: 'auto', mt: 3 }}>
          <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
            {ids.map((id, index) => (
              <Button
                key={id}
                onClick={() => setActiveTab(index)}
                variant={activeTab === index ? 'contained' : 'text'}
                sx={{
                  background: activeTab === index ? '#005d83' : '#f5f5f5',
                  borderRadius: 100,
                  height: 40,
                  minWidth: 40,
                }}
              >
                {index + 1}
              </Button>
            ))}
          </Box>
        </Grid>
        <EikenMaterialGeneratedForm key={data.id} eikenMaterial={data} />
      </Page.Content>
    </Page>
  );
}
